import { Heading } from "../../components/heading/Heading"
import PrivacyPolConstants from "./PrivacyPolConstants"
import htmlParser from 'html-react-parser'

export const PrivacyPol = () => {
    return (
        <>
            <Heading level={1}>{PrivacyPolConstants.PRIVACY_POLICY}</Heading>
            {
                PrivacyPolConstants.PARAS.map((p, idx) => (
                    <p key={idx}>{htmlParser(p)}</p>
                ))
            }
        </>
    )
}